var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Reviews","doc":_vm.doc}},[_c('template',{slot:"header"},[_c('v-chip',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.reviews.length))])],1),_c('List',{attrs:{"reviews":_vm.reviews}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }